export class JobSalary {
    maxSalary: number = 0;
    minSalary: number = 0;
    salaryType: any = null;
    salaryDuration: any = "PER_YEAR";
    currency: any = null;
}